var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',{staticClass:"head",attrs:{"height":"71"}},[_c('span',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":""}})]),_c('span',[_vm._v(" 电子合同服务平台 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }